<template>

    <div class="row">
        <div class="col-md-12">
            <div class="card mb-5">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-9">
                            <p class="h3">{{__("messages.success_voucher")}}</p>
                            <p v-if="!rapd" class="font-18 mt-2">{{__("messages.processing_booking")}}</p>
                            <p v-if="rapd" class="font-18 mt-2">{{__("messages.your_reservation_is_confirmed")}}</p>
                        </div>
                        <div class="col-md-3">
                            <div class="border border-secondary text-center rounded py-2">
                                <p> {{__("messages.reservacion_id")}} </p>
                                <p class="font-weight-bold h4"> {{data.id}} </p>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <p class="mt-2" v-html="__('messages.we_send_email',[data.email])">
                            </p>
                            <p class="h5 mt-5">  {{__("messages.description_voucher")}} </p>
                            <p v-html="__('messages.description_voucher_detail', [siteConfig.appName])">
                            </p>
                        </div>
                        
                        <div class="col-md-12" v-if="culture.cultureCode === 'es-mx' && rapd">
                            <voucher-rapd-instructions></voucher-rapd-instructions>
                        </div>

                        <div class="col-md-12 text-center" v-if="retry">
                            <p class="mt-2 font-weight-bold"> {{__("messages.please_wait_voucher")}} </p>
                            <div class="d-flex justify-content-center loader-retry"> <div class="loader__circle"></div> </div>
                        </div>


                        <div class="col-12 mt-5"><a :href="'/'+ culture.cultureCode + __('url.url_go_home')" class="link">{{__("messages.go_home")}}</a></div>
                    </div>

                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import { AlgoliaServices } from '../../services/AlgoliaService';
    import VoucherRapdInstructions from './VoucherRapdInstructions';

    const site = window.__pt.settings.site;
    const culture = window.__pt.cultureData;
    export default {
        props: ['data', 'retry', 'rapd'],
        data() {
            return {
                type: {},
                siteConfig: site,
                culture
            };
        },
        async mounted() {
            this.getEventAlgolia();
        },
        methods: {
            getEventAlgolia() {
                AlgoliaServices.getEventAlgolia("Order", "purchase");
            }
        },
        components: {
            VoucherRapdInstructions
        }
    }
</script>
